<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader

    main
      v-container.text-xs-center.primary--text
        h1 ラインナップ・商品詳細
      div.cate_juicies.pb-5
        v-layout(row wrap).justify-center
          img(src="static/images/logo.png" width="250px" height="93px")
        h2.primary--text.my-2 ジューシーズシリーズ
        p.text-xs-center.mb-5
          | 後味すっきり！
          br
          | フルーツ本来の甘みが口いっぱいに広がる、
          br
          | 暑い時にぴったりの爽やかなアイスです。
        v-layout(v-for="item in categoryJuicies" :key="item.key")
            v-container.item_wrap(fluid)
              v-layout(row wrap)
                v-flex.item_img.justify-center(sm1 offset-sm2)
                  img(:src="item.display.image.itemImg.src" :alt="item.display.image.itemImg.alt")
                v-flex.new_wrapper(sm1)
                  span.new(v-if="item.new") NEW!
                v-flex.item_right(sm6)
                  v-layout(row wrap)
                    v-flex.item_txt(xs12 sm12)
                      h3.primary--text.text-xs-center.text-sm-left {{item.prefixTitle}}
                        br
                        |{{item.title}} {{item.title2}}
                      p(v-for="(description, descriptionIndex) in item.display.descriptions" :key="descriptionIndex") {{description}}
                  v-flex.item_point
                    span(:style="{backgroundColor: item.display.color}") {{item.percentage}}
                    span(:style="{backgroundColor: item.display.color}") 砂糖・甘味料・着色料 不使用
                    span(:style="{backgroundColor: item.display.color}") カロリー {{item.energy}}kcal
                  table
                    tbody
                      tr(v-for="(ingredient, ingredientIndex) in item.display.ingredients" :key="ingredientIndex")
                        th(:style="{backgroundColor: item.display.lightColor}")
                          span.d-block(v-for="(title, titleIndex) in ingredient.titles" :key="titleIndex") {{title}}
                        td(v-if="ingredient.complex")
                          dl(v-for="(content, contentIndex) in ingredient.contents" :key="contentIndex" )
                            dt {{content.title}}
                            dd {{content.content}}
                        td(v-else)
                          span.d-block(v-for="(content, contentIndex) in ingredient.contents" :key="contentIndex") {{content}}

      div.cate_coconuts.py-5
        v-layout(row wrap).justify-center
          img(src="static/images/logo_coconut.png" width="220px" height="104px")
        h2.primary--text.mt-3.mb-2 ココナッツジューシーズシリーズ
        p.text-xs-center.mb-5
          | 果汁感はそのままにココナッツクリームをミックス!
          br
          | ジューシーでなめらか!
          br
          | ココナッツの風味がふわっと香ります。
        v-layout(v-for="item in categoryCoconuts" :key="item.key")
            v-container.item_wrap(fluid)
              v-layout(row wrap)
                v-flex.item_img.justify-center(sm1 offset-sm2)
                  img(:src="item.display.image.itemImg.src" :alt="item.display.image.itemImg.alt")
                v-flex.new_wrapper(sm1)
                  span.new(v-if="item.new") NEW!
                v-flex.item_right(sm6)
                  v-layout(row wrap)
                    v-flex.item_txt(xs12 sm12)
                      h3.primary--text.text-xs-center.text-sm-left {{item.prefixTitle}}
                        br
                        |{{item.title}}
                      p(v-for="(description, descriptionIndex) in item.display.descriptions" :key="descriptionIndex") {{description}}
                  v-flex.item_point
                    span(:style="{backgroundColor: item.display.color}") {{item.percentage}}
                    span(:style="{backgroundColor: item.display.color}") 砂糖・甘味料・着色料 不使用
                    span(:style="{backgroundColor: item.display.color}") カロリー {{item.energy}}kcal
                  table
                    tbody
                      tr(v-for="(ingredient, ingredientIndex) in item.display.ingredients" :key="ingredientIndex")
                        th(:style="{backgroundColor: item.display.lightColor}")
                          span.d-block(v-for="(title, titleIndex) in ingredient.titles" :key="titleIndex") {{title}}
                        td(v-if="ingredient.complex")
                          dl(v-for="(content, contentIndex) in ingredient.contents" :key="contentIndex" )
                            dt {{content.title}}
                            dd {{content.content}}
                        td(v-else)
                          span.d-block(v-for="(content, contentIndex) in ingredient.contents" :key="contentIndex") {{content}}

      v-container(style="font-size: .6rem;")
        span ※製品中の茶色又は黒っぽい粒は、果汁由来のものです。
        br
        span.indent ※本製品はりんごのストレート果汁をベースに作られているため、天候や季節により味が若干変動する場合がございます。予めご了承いただきますようお願いいたします。

    CommonFooter
    span.footer_pic

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'
import { mapGetters } from 'vuex'

import _ from 'underscore'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('app', ['items']),
    categoryJuicies () {
      return _.filter(this.items, function (item) {
        return item.category === 'juicies'
      })
    },
    categoryCoconuts () {
      return _.filter(this.items, function (item) {
        return item.category === 'coconuts'
      })
    }
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

.item_img
  display -ms-flexbox
  display flex
  justify-content right
  -ms-flex-align-items center
  align-items center
  +breakpoint(xs)
    margin-left 40%
    justify-content center
  img
    +breakpoint(xs)
      height 200px
      margin-bottom 10px
      margin-right 50%

.item_point
  display block
  border-radius 3px
  margin 10px 0 40px 3px
  span
    text-align center
    border-radius 3px
    font-size 0.8rem
    padding 1px 8px
    margin 5px 5px 0 0
    line-height 1rem
    float left
    display inline
    color #fff
    font-weight bold
    +breakpoint(sm)
      padding 3px 8px 1px
table
  width 100%
  th,td
    padding 3px!important
    font-size 0.7rem
    line-height 0.9rem
    height auto
    font-weight normal
  th
    width 10rem

  th span,dl span
    font-size 0.9em
    line-height 0.8rem
    white-space nowrap
dl
  dt
    float left
  dd
    float left
    margin-right 10px
    height auto

.cate_coconuts
  background url(../../../../../static/images/bg_paper.png) repeat
  td
    background-color #fffaf3
  .item_wrap
    border-top 1px dotted #d5ae94

.cate_juicies
  .item_wrap
    border-top 1px dotted #f0e8e3

.new_wrapper
  position relative
  padding 5px 0

.new
  display inline-block
  position absolute
  right 10px
  top -26px
  margin 0
  padding 20px 0 15px
  z-index 2
  width 50px
  text-align center
  font-weight bold
  font-size 1rem
  font-family 'Dokdo', cursive
  color #fff
  background linear-gradient(#ff785b 0%, #e95738 100%)
  border-radius 2px 0 0 0
  +breakpoint(sm)
    top -20px
  &:before
    position absolute
    content ''
    top 0
    right -6px
    border none
    border-bottom solid 6px #cf4a2d
    border-right solid 6px transparent
  &:after
    content ''
    position absolute
    left 0
    top 100%
    height 0
    width 0
    border-left 25px solid #e95738
    border-right 25px solid #e95738
    border-bottom 10px solid transparent

//Footer
.footer_pic
  background url(../../../../../static/images/footer_pic_chara_j.png) no-repeat
  background-position bottom 0 right -15px

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Item/index.vue